import { Constants } from "../../../../../../../utils/constants"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"
import { calc30DaysAgo } from "../../indicators/methods/callEndpoints"

const formatTop15 = (payload: ObjectGeneric, order: 'asc' | 'desc') => {
    let sortOrder = order
    if (payload?.topQuestionnaires) {
        if (payload.topQuestionnaires === 1) {
            sortOrder = 'desc'
        } else if (payload.topQuestionnaires === 2) {
            sortOrder = 'asc'
        }
    }

    const { startDate, endDate } = calc30DaysAgo({
        end: payload?.to,
        start: payload?.from,
        format: Constants.dateEndpoint2
    })
    let filters: any = []

    if (payload?.from || payload?.to) {
        filters.push({
            "range": {
                [payload?.intervale?.value == '1w' ? 'fecha_inicio_semana' : 'fecha_inicio']: {
                    "gte": payload?.from ? startDate : null,
                    "lte": payload?.to ? endDate : null
                }
            }
        })
    }

    if (!!payload?.divisions?.length) {
        filters.push({
            "terms": {
                "division_unidad_id": (payload?.divisions as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.units?.length) {
        filters.push({
            "terms": {
                "unidad_id": (payload?.units as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.areas?.length) {
        filters.push({
            "terms": {
                "area_id": (payload?.areas as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.departments?.length) {
        filters.push({
            "terms": {
                "departamento_id": (payload?.departments as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.status?.length) {
        filters.push({
            "terms": {
                "cuestionario_estatus_id": (payload?.status as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.questionnaire?.length) {
        filters.push({
            "terms": {
                "cuestionario_id": (payload?.questionnaire as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.users?.length) {
        filters.push({
            "terms": {
                "usuario_id": (payload?.users as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.grades?.length) {
        filters.push({
            "range": {
                "cuestionario_resultado": {
                    "gte": payload?.grades?.[0],
                    "lte": payload?.grades?.[1],
                },
            },
        })
    }
    if (!!payload?.percentage?.length) {
        filters.push({
            "range": {
                "avance": {
                    "gte": payload?.percentage?.[0],
                    "lte": payload?.percentage?.[1],
                },
            },
        })
    }

    if (payload?.estatus && (Array.isArray(payload?.estatus) ? payload?.estatus?.length > 0 : payload?.estatus)) {
        const estatusValues = Array.isArray(payload?.estatus)
            ? (payload?.estatus as Item[])?.map(item => item.value)
            : [payload?.estatus?.value || payload?.estatus];

        filters.push({
            terms: {
                estatus_id: estatusValues,
            },
        })
    }

    const body = {
        "size": 0,
        "query": {
            "bool": {
                "filter": filters
            }
        },
        "aggs": {
            "ranking_unidades": {
                "terms": {
                    "field": "unidad_id",
                    "size": 1000,
                    "order": {
                        "promedio_resultados": sortOrder
                    }
                },
                "aggs": {
                    "promedio_avance": {
                        "avg": {
                            "field": "avance"
                        }
                    },
                    "total_preguntas": {
                        "sum": {
                            "field": "total_preguntas"
                        }
                    },
                    "total_preguntas_contestadas": {
                        "sum": {
                            "field": "preguntas_contestadas"
                        }
                    },
                    "cuestionarios_finalizados": {
                        "filter": {
                            "term": {
                                "cuestionario_estatus_id": 8
                            }
                        }
                    },
                    "cuestionarios_en_proceso": {
                        "filter": {
                            "terms": {
                                "cuestionario_estatus_id": [1, 2, 3, 5, 6,17]
                            }
                        }
                    },
                    "cuestionarios_no_iniciados": {
                        "filter": {
                            "term": {
                                "cuestionario_estatus_id": 9
                            }
                        }
                    },
                    "cuestionarios_vencidos": {
                        "filter": {
                            "term": {
                                "cuestionario_estatus_id": 21
                            }
                        }
                    },
                    "total_cuestionarios_programados": {
                        "value_count": {
                            "field": "cuestionario_id"
                        }
                    },
                    "promedio_resultados": {
                        "avg": {
                            "field": "resultado_agendamiento"
                        }
                    },
                    "ultimo_registro": {
                        "top_hits": {
                            "size": 1,
                            "sort": [
                                {
                                    "fecha": {
                                        "order": "desc"
                                    }
                                }
                            ],
                            "_source": [
                                "unidad_id",
                                "unidad",
                                "unidad_ceco",
                                "division_unidad",
                                "usuario",
                                "cuestionario",
                                "semana",
                                "fecha",
                            ]
                        }
                    }
                }
            }
        }
    }

    return {
        body
    }
}

export { formatTop15 }